import { Component } from "@angular/core";

@Component({
    selector: "app-main-dashboard",
    templateUrl: "./main-dashboard.component.html",
    styleUrls: ["./main-dashboard.component.scss"],
})
export class MainDashboardComponent {
    public threatModel: "mitreBySeverities" | "owaspBySeverities" | "owaspLlmBySeverities" = "owaspBySeverities";

    public currentFilterCategory() {
        if (this.threatModel === "mitreBySeverities") return "mitre";
        if (this.threatModel === "owaspBySeverities") return "owaspLcnc";
        if (this.threatModel === "owaspLlmBySeverities") return "owaspLlm";
        return "No filter was found";
    }
}
